import { graphql } from "react-apollo"

import CartButton, { PassthroughProps } from "../components/CartButton"
import getCart from "../queries/getCart"

export default graphql<PassthroughProps, unknown, unknown, PassthroughProps>(
  getCart
)(CartButton)
